import { AppState } from '..';
import { Country } from './country.types';

export const countrySelector = (state: AppState): Country[] =>
  state.countries.country!;
